enum MutationType {
  TOGGLE_AUDIO_NOTIFICATION = "ui/TOGGLE_AUDIO_NOTIFICATION",
  TOGGLE_TEXT_NOTIFICATION = "ui/TOGGLE_TEXT_NOTIFICATION",
  TOGGLE_DIR_LIST_SHOWN = "ui/TOGGLE_DIR_LIST_SHOWN",
  TOGGLE_ACTIONS_LIST_SHOWN = "ui/TOGGLE_ACTIONS_LIST_SHOWN",
}

export default MutationType;
